import io from '../../lib/io'
export default {
    state:{//state
        nums: 0
    },
    mutations:{
        addShoppingCarNum(state){//这里的state对应着上面这个state
            state.nums ++ ;
            //你还可以在这里执行其他的操作改变state
        },
        delShoppingCarNum(state){
            state.nums -- ;
        },
        initStateNums(state,num){
            state.nums = num;
            // console.log(state.nums)
        },
        batchDelCarNum(state,num){
            state.nums = state.nums-num
        }
    },
    actions:{
        loadCartNum(commit) {
            if (localStorage.getItem("accessToken")) {
                io.post(io.cartNum, {}, (data) => {
                    if (data.success) {
                        let nums = Number(data.data);
                        commit.commit('initStateNums',nums)
                          
                    } else {
                        commit.commit('initStateNums', 0);
                    }
                });
            } else {
                commit.commit('initStateNums', 0);
            }
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/store/carNums.js